import RootApp from './RootApp';

export default RootApp;